module.exports = __webpack_public_path__ + "img/mac-mount.2638b82f.svg";